function saveFile(blob: Blob, fileName: string, fileType: string) {
  return new Promise<void>((resolve, reject) => {
    // const dataView = new DataView(plaintext);
    // const blob = new Blob([dataView], { type: fileType });

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName);
      return resolve();
    } else {
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(downloadUrl);
      setTimeout(resolve, 100);
    }
  });
}

export default saveFile;
